
export const monochromeDarkStyle = [
  {
    "elementType": "geometry",
    "stylers": [
      { "color": "#1d1d1d" }   // Fondo general oscuro
    ]
  },
  {
    "elementType": "labels.text.fill",
    "stylers": [
      { "color": "#8e8e8e" }   // Texto gris suave
    ]
  },
  {
    "elementType": "labels.text.stroke",
    "stylers": [
      { "color": "#1d1d1d" }
    ]
  },
  {
    "featureType": "administrative",
    "elementType": "geometry",
    "stylers": [
      { "visibility": "off" } // quitar bordes administrativos
    ]
  },
  {
    "featureType": "poi",
    "stylers": [
      { "visibility": "off" } // quitar puntos de interés
    ]
  },
  {
    "featureType": "road",
    "elementType": "geometry",
    "stylers": [
      { "color": "#2c2c2c" }   // calles gris oscuro
    ]
  },
  {
    "featureType": "road",
    "elementType": "geometry.stroke",
    "stylers": [
      { "color": "#3c3c3c" }
    ]
  },
  {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [
      { "color": "#0d47a1" }   // agua azul profundo (puedo ponértelo gris también)
    ]
  }
];
